import 'utils/dates';

import dayjs from 'dayjs';
import { IToast } from 'interfaces';
import dynamic from 'next/dynamic';
import Head from 'next/head';
import React, { Fragment, useEffect } from 'react';

import Toast from 'components/elements/Toast';
import useToastStore from 'modules/toast/stores/toastStore';
import { ContextualModalAnimationPrefetch } from 'modules/upsells/components/modals/Contextual/ContextualModalAnimationPrefetch';
import { GlobalUpsellModalAnimationPrefetch } from 'modules/upsells/components/modals/Global/GlobalUpsellModalAnimationPrefetch';
import { useLanguages } from 'modules/user-page/containers/hooks/useLanguages';

const CheckoutModal = dynamic(() => import('modules/checkout/components/CheckoutModal'), { ssr: false });

export const MainWrapper = ({ children }: { children: React.ReactNode }) => {
  const toasts = useToastStore(state => state.toasts);
  const { language } = useLanguages();

  useEffect(() => {
    const chineeseLocales = ['zh-Hant', 'zh-Hans'];
    const locale = chineeseLocales.includes(language.locale) ? 'zh' : language.locale;
    dayjs.locale(locale);
  }, [language.locale]);

  return (
    <Fragment>
      <Head>
        <meta name="viewport" content="width=device-width, initial-scale=1" />
      </Head>
      {/* Prefetch Lottie animations for contextual modals only for trial users */}
      <ContextualModalAnimationPrefetch />
      <GlobalUpsellModalAnimationPrefetch />
      <div aria-live="assertive" className="pointer-events-none fixed inset-0 flex items-end px-4 py-6 sm:items-start sm:p-6" style={{ zIndex: 9999 }}>
        <div className="flex w-full flex-col items-center space-y-4">
          {toasts.map((toast: IToast, i: number) => (
            <Toast toast={toast} key={i} />
          ))}
        </div>
      </div>
      <CheckoutModal />
      {children}
    </Fragment>
  );
};

export default MainWrapper;
